import { render } from "./IreV2Values.vue?vue&type=template&id=8691c71c&ts=true"
import script from "./IreV2Values.vue?vue&type=script&lang=ts"
export * from "./IreV2Values.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__